import { FormControl, InputAdornment, OutlinedInput, useMediaQuery} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { Search } from '@mui/icons-material';
import { useState } from 'react';


const MenuSearchInput = (): JSX.Element => {

    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));

    const [searchInput, setSearchInput] = useState<string>('');

    const changeSearchInput = (event: any) => {
        setSearchInput(event.target.value);
    };

    const updateSearchInput = () => {
        window.location.href = '/Search?q=' + searchInput;
     }

     const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            updateSearchInput();
        }
      };

    return(
        <FormControl size="small" sx={{ m: 0, p:0, maxWidth: isSM?110:160 }}>
          <OutlinedInput
             placeholder={isSM?"Search": "Search OCPF"}
             onKeyDown={handleKeyDown}
             endAdornment={
                <InputAdornment className='is-clickable' position="end" onClick={updateSearchInput}>
                  <Search />
                </InputAdornment>
              }
              onChange={changeSearchInput}
              sx={{ fontSize: 'medium' }}
          />
        </FormControl>
    )
}

export default MenuSearchInput;